<template>
  <div v-if="show" class="loading">
    <v-row align="center">
      <v-row justify="center">
        <v-progress-circular
          :width="3"
          color="secondary"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import eventBus from '../../utils/eventBus'
export default {
  name: 'Loading',
  data () {
    return {
      show: false
    }
  },
  methods: {
    showLoading () {
      this.show = true
    },
    hideLoading () {
      this.show = false
    }
  },
  beforeMount () {
    eventBus.$on('showLoading', this.showLoading)
    eventBus.$on('hideLoading', this.hideLoading)
  },
  beforeDestroy () {
    eventBus.$off('showLoading', this.showLoading)
    eventBus.$off('hideLoading', this.hideLoading)
  }
}
</script>

<style scoped lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  display: flex;
  justify-content: center;
  align-content: center;
  z-index: 1000;
}
</style>
